import {useState,useEffect} from 'react';

const useChangeSlider = (timeFrame) =>{
    const [slideIndex,setSlideIndex] = useState(1);

    useEffect(()=>{
        document.getElementById('radio' + slideIndex).checked = true;
    },[slideIndex])

    useEffect(()=>{
    const interval = setInterval(() => {
        setSlideIndex(slideIndex => slideIndex + 1);
        if(slideIndex === (timeFrame / 1000)){
            setSlideIndex(1)
        }
    }, timeFrame);

    return () => clearInterval(interval);
    },[slideIndex,timeFrame])


    return [slideIndex, setSlideIndex];
}

export default useChangeSlider;